export default __webpack_public_path__ + "static/media/valle_cocora.24dba0f5.jpeg";